<template>
  <div class="page-wrapper">
    <div class="ticket-aside">
      <div class="ticket-aside__inner">
        <TicketFull
          :ticket-servicing="$store.currentTicketServicing"
          :ticket="$store.currentTicket"
          @ticketNext="onNextSelectTicket"
          @ticketClose="onTicketClose"
          @ticketPostpone="onTicketPostpone"
          @ticketRecall="onTicketRecall"
          @ticketAbsence="onTicketAbsence"
          @ticketRedirect="onTicketRedirect"
          @orderAssembled="onOrderAssembled"
          @changeStatus="onChangeStatus"
          @menu="onMenuOpen"
          @openMobileTickets="mobileTicketsOpen"
        />
      </div>
    </div>
    <div
      class="tickets-list"
      :class="{'is--mobile-tickets-open': isTicketsOpen}"
    >
      <TicketsHeading
        :tabs="tabs"
        :active="tabActive"
        @changeTab="changeTab"
        @searchChange="searchChange"
        @searchClose="searchClose"
        @searchOpen="searchOpen"
        @mobileClose="mobileTicketsClose"
      />
      <div
        ref="ticketsList"
        v-click-outside="closeContextMenu"
        class="tickets-list__body"
        :class="{'is--mobile-open': isSearchOpen}"
      >
        <TicketsGroup
          v-if="tabActive === tabsTypes.QUEUE && !searchPanelOpen"
          :tickets="$store.waitingTickets"
          text="d_ws_tab_queue_empty"
          @ticketClick="openContextMenu($event, false,[CONTEXT_MENU_ACTIONS.CALL], $store.waitingTickets)"
        />
        <TicketsGroup
          v-else-if="tabActive === tabsTypes.POSTPONED && !searchPanelOpen"
          :tickets="$store.postponedTickets"
          text="d_ws_tab_postponed_empty"
          @ticketClick="openContextMenu($event, true,[CONTEXT_MENU_ACTIONS.BACK_TO_ALIVE, CONTEXT_MENU_ACTIONS.CALL], $store.postponedTickets)"
        />
        <TicketsGroup
          v-else-if="tabActive === tabsTypes.READIED && !searchPanelOpen"
          :tickets="$store.readiedTickets"
          text="d_ws_tab_readied_empty"
          @ticketClick="openContextMenu($event, true,[CONTEXT_MENU_ACTIONS.ISSUED], $store.readiedTickets)"
        />
        <TicketsGroup
          v-else-if="tabActive === tabsTypes.CANCELED && !searchPanelOpen"
          :tickets="$store.canceledTickets"
          text="d_ws_tab_canceled_empty"
          @ticketClick="openContextMenu($event, false,[CONTEXT_MENU_ACTIONS.BACK_TO_ALIVE, CONTEXT_MENU_ACTIONS.CALL], $store.canceledTickets)"
        />
        <TicketsSearchGroup
          v-else-if="searchPanelOpen"
          :tickets="$store.foundTickets"
          @ticketClick="openContextMenu($event, searchContextMenuParams.accessForOperator, searchContextMenuParams.actions, searchContextMenuParams.tickets)"
        />
      </div>
    </div>
    <ContextMenu
      v-if="contextMenu.open"
      :top="contextMenu.top"
      :left="contextMenu.left"
      :actions="$store.contextMenuActions"
      @call="onTicketCallButtonClick"
      @back_to_alive="onBackToAlive"
      @issued="onOrderIssued"
    />
    <AsideMenu
      :menu="menu"
      @menuClose="menuClose"
    />
    <MobileCallTicketModal />
    <RedirectModal />
    <ChangeLanguageModal />
    <AddTagsModal />
    <UserProfileModal />
    <ChangeStatusModal />
    <AliveModal />
    <EditRouteModal v-if="$store.isEditRoute" />
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import Ticket from '../Dashboard/Ticket'
import TicketFull from '../Dashboard/TicketFull'
import TicketsGroup from '../Dashboard/TicketsGroup'
import AsideMenu from '../Dashboard/AsideMenu'
import TicketsHeading from "../Dashboard/TicketsHeading";
import TicketsSearchGroup from "../Dashboard/TicketsSearchGroup";
import ContextMenu from '../controls/ContextMenu';
import {parseJSON} from '../../../../../helpers/utils'

import RedirectModal from "../modals/RedirectModal";
import ChangeLanguageModal from "../modals/ChangeLanguageModal";
import AddTagsModal from "../modals/AddTagsModal";
import UserProfileModal from "../modals/UserProfileModal";
import ChangeStatusModal from "../modals/ChangeStatusModal";
import MobileCallTicketModal from "../modals/MobileCallTicketModal";
import AliveModal from "../modals/AliveModal";
import EditRouteModal from "../modals/EditRouteModal";

import { TICKET_STATUS, USER_STATUSES, TABS, CONTEXT_MENU_ACTIONS, REDIRECT_MODE } from '../../config'
import SocketMessages from '../../../../../helpers/socketMessages';

export default {
  components: {
    Ticket,
    TicketFull,
    TicketsGroup,
    AsideMenu,
    TicketsHeading,
    TicketsSearchGroup,
    RedirectModal,
    ChangeLanguageModal,
    AddTagsModal,
    UserProfileModal,
    ChangeStatusModal,
    MobileCallTicketModal,
    AliveModal,
    EditRouteModal,
    ContextMenu
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      menu: false,
      OPERATOR_WORKSPACE_SOCKET_EVENT: {
        [SocketMessages.RegisterNewTicket]: this.onRegisterNewTicket,
        [SocketMessages.AppointTicket]: this.onAppointTicket,
        [SocketMessages.CallTicket]: this.onCallTicket,
        [SocketMessages.RedirectTicket]: this.reloadAllState,
        [SocketMessages.PostponeTicket]: this.reloadAllState,
        [SocketMessages.CancelTicket]: this.reloadAllState,
        [SocketMessages.BackToAliveTicket]: this.reloadAllState,
        [SocketMessages.ReadiedTicket]: this.$store.isIssuingPoint && this.reloadAllState,
        [SocketMessages.CloseTicket]: this.$store.isIssuingPoint && this.reloadAllState
      },
      tabsTypes: TABS,
      defaultTabs: [
        {
          id: TABS.QUEUE,
          title: 'd_ws_tab_queue',
          count: 0,
          icon: 'ri-group-line',
          denyAccess: []
        },
        {
          id: TABS.POSTPONED,
          title: 'd_ws_tab_postponed',
          count: 0,
          icon: 'ri-pause-circle-line',
          denyAccess: []
        },
        {
          id: TABS.CANCELED,
          title: 'd_ws_tab_canceled',
          count: 0,
          icon: 'ri-close-circle-line',
          denyAccess: [4]
        },
        {
          id: TABS.SEARCH
        },
      ],
      readiedTab: {
        id: TABS.READIED,
        title: 'd_ws_tab_readied',
        count: 0,
        icon: 'ri-barcode-box-line',
        denyAccess: []
      },
      tabActive: 1,
      searchPanelOpen: false,
      contextMenu: {
        open: false,
        left: '0px',
        top: '0px',
        ticket: null,
        ticketsArray: null
      },
      isSearchOpen: false,
      isTicketsOpen: true,
      ticketServicingTimerSub: null,
      mobileCallTicketUnsub: null,
      statusChangeUnsub: null,
      initSocketsUnsub: null,
      reloadUnsub: null,
      socketReconnectUnsubscription: null,
      socketMessageUnsubscription: null,
      currentQueueTickets: null,
    }
  },
  computed: {
    CONTEXT_MENU_ACTIONS() {
      return CONTEXT_MENU_ACTIONS
    },
    REDIRECT_MODE() {
      return REDIRECT_MODE
    },
    canIssueOrder() {
      return this.$store.isIssuingPoint
    },
    tabs() {
      if (this.canIssueOrder) {
        return [...this.defaultTabs, this.readiedTab];
      }

      return [...this.defaultTabs];
    },
    searchContextMenuParams() {
      switch (this.tabActive) {
      case 1: // QUEUE
        return {
          accessForOperator: false,
          actions: [CONTEXT_MENU_ACTIONS.CALL],
          tickets: this.$store.waitingTickets
        };
      case 2: // POSTPONED
        return {
          accessForOperator: true,
          actions: [CONTEXT_MENU_ACTIONS.BACK_TO_ALIVE, CONTEXT_MENU_ACTIONS.CALL],
          tickets: this.$store.postponedTickets
        };
      case 3: // READIED
        return {
          accessForOperator: true,
          actions: [CONTEXT_MENU_ACTIONS.ISSUED],
          tickets: this.$store.readiedTickets
        };
      case 4: // CANCELED
        return {
          accessForOperator: false,
          actions: [CONTEXT_MENU_ACTIONS.BACK_TO_ALIVE, CONTEXT_MENU_ACTIONS.CALL],
          tickets: this.$store.canceledTickets
        };
      default:
        return {
          accessForOperator: false,
          actions: [CONTEXT_MENU_ACTIONS.CALL],
          tickets: this.$store.waitingTickets
        };
      }
    },
  },
  beforeDestroy() {
    this.$refs.ticketsList.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.$refs.ticketsList.addEventListener('scroll', this.handleScroll);
    Promise.all([
      this.getCurrentState(),
    ]).then((resp) => {
      if (!this.$socketService.webSocketReady) {
        this.$socketService.connect(this.$deviceConfig.SOCKET_URL, this.$deviceConfig.SOCKET_ASSOCIATED_DEVICE_PARAM);
        this.initSocketsUnsub = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.SOCKETS_OPEN, () => {
          this.initComponent(resp);
        });
      } else {
        this.initComponent(resp);
      }

      this.reloadUnsub = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.WORKSPACE_RELOAD, () => {
        this.reloadAllState();
      });
    });

    this.mobileCallTicketUnsub = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.MOBILE_CALL_TICKET, () => {
      this.isTicketsOpen = false;
    });
    this.statusChangeUnsub = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.STATUS_CHANGE, () => {
      this.$ticketService.clearAutoCallTimer();
    })
  },
  destroyed() {
    if (this.mobileCallTicketUnsub) this.mobileCallTicketUnsub();
    if (this.statusChangeUnsub) this.statusChangeUnsub();
    if (this.initSocketsUnsub) this.initSocketsUnsub();
    if (this.reloadUnsub) this.reloadUnsub();
    if (this.socketReconnectUnsubscription) this.socketReconnectUnsubscription();
    if (this.socketMessageUnsubscription) this.socketMessageUnsubscription();
  },
  methods: {
    onRegisterNewTicket(ticket) {
      if (this.$store.waitingTickets.length === 0) {
        this.reloadAllState();
      } else {
        this.checkAndPushTicket(ticket);
      }
    },
    onAppointTicket(ticket) {
      if (this.$store.waitingTickets.length === 0) {
        this.reloadAllState();
      } else {
        this.checkAndPushTicket(ticket);
      }
    },
    onCallTicket(ticket) {
      if (ticket) {
        this.removeTicketFromQueue(ticket.id);
        if (!this.$store.waitingTickets.length) {
          this.reloadAllState();
        }
      }
    },
    checkAndPushTicket(ticket) {
      const currentTicketOfficeServiceId = ticket.office_service_id;
      const isMainService = this.$store.deviceStartData.window.main_office_service_group_links ? !!this.$store.deviceStartData.window.main_office_service_group_links.find(item => item === currentTicketOfficeServiceId) : false;

      if (!this.$store.lastCurrentStateMode) {
        if (isMainService) {
          this.pushTicketInQueue(ticket);
        }
      } else {
        if (!isMainService) {
          this.pushTicketInQueue(ticket);
        } else {
          this.reloadAllState();
        }
      }
    },
    pushTicketInQueue(ticket) {
      this.$store.unsortedTickets.push(ticket);
      this.makeQueue();
    },
    removeTicketFromQueue(id) {
      const ticketIdx = this.$store.unsortedTickets.findIndex(item => item.id === id);
      if (ticketIdx !== -1) {
        this.$store.unsortedTickets.splice(ticketIdx, 1);
        this.makeQueue();
      }
    },
    initComponent(resp) {
      this.initState(resp[0]);
      this.ticketServicingTimerSub = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.AUTOCALL_CALL, () => {
        if (this.$store.currentStatus === 1) {
          this.onNextSelectTicket();
        }
      });
      this.$initService.authorizeOperatorDevice(localStorage.getItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.TOKEN), this.$store.deviceStartData.device.token);
      this.websocketSubscribe();
    },
    handleScroll() {
      this.contextMenu.open = false;
    },
    initState(resp) {
      return new Promise((res, rej) => {
        if (this.$store.deviceStartData.window) {
          this.$store.unsortedTickets = resp.data.tickets_queue;
          this.$store.currentTicket = resp.data.current_ticket;

          this.$store.currentStatus = resp.data.current_status.tag_id;
          this.$store.currentStatusTimestamp = resp.data.current_status.start_time;

          this.splitIntoGroups();

          if (this.$store.currentTicket && this.$store.currentTicket.ticket_servicing_list) {
            this.$store.currentTicketServicing = this.$store.currentTicket.ticket_servicing_list[this.$store.currentTicket.ticket_servicing_list.length - 1];
            const service = this.$ticketService.getCurrentService(this.$store.currentTicketServicing.office_service_id);
            if (service) {
              this.$ticketService.startTicketTimer((service.time_limit * 60) * 2);
            }
          } else if (this.$store.currentStatus === USER_STATUSES.IDLE) {
            this.startAutoCallTimer();
          }

          res()
        } else {
          this.$authService.clearUser();
          rej()
        }
      })
    },
    onMenuOpen() {
      this.menu = true;
    },
    menuClose() {
      this.menu = false;
    },
    mobileTicketsOpen() {
      this.isTicketsOpen = true;
    },
    mobileTicketsClose() {
      this.isTicketsOpen = false;
    },
    changeTab(id) {
      this.tabActive = id;
    },
    searchChange(searchString) {
      if (searchString) {
        let activeTicketsArray;

        switch (this.tabActive) {
        case 1:
          activeTicketsArray = this.$store.waitingTickets;
          break;
        case 2:
          activeTicketsArray = this.$store.postponedTickets;
          break;
        case 4:
          activeTicketsArray = this.$store.canceledTickets;
          break;
        }

        this.$store.foundTickets = activeTicketsArray.filter((ticket) => {
          const service = this.$ticketService.getCurrentService(ticket.office_service_id);

          if (service) {
            const title = this.$ticketService.getServiceTitle(service).toLowerCase();
            const ticketNumber = (ticket.prefix + ticket.number).toLowerCase();

            if (title.search(searchString) !== -1 || ticketNumber.search(searchString) !== -1) {
              return ticket;
            }

            return false;
          }
        });
        this.searchPanelOpen = true;
      } else {
        this.searchPanelOpen = false;
      }
    },
    searchClose() {
      this.isSearchOpen = false;
      this.searchPanelOpen = false;
    },
    searchOpen() {
      this.isSearchOpen = true;
    },
    callTicket(ticket, sourceTicketsArray = null) {
      // Используем переданный массив или определяем по статусу тикета
      this.currentQueueTickets = sourceTicketsArray ||
        (ticket.status_type === TICKET_STATUS.POSTPONED ? this.$store.postponedTickets :
          ticket.status_type === TICKET_STATUS.CANCELED ? this.$store.canceledTickets :
            ticket.status_type === TICKET_STATUS.READIED ? this.$store.readiedTickets :
              this.$store.waitingTickets);

      if (this.$store.ticketTransactionEnd) {
        this.$ticketService.callTicket(ticket.id).then((resp) => {
          this.$store.currentTicket = this.currentQueueTickets.find((ticket) => ticket.id === resp.data.ticket_id);
          this.$store.currentStatus = USER_STATUSES.WORKING;
          this.$store.currentTicketServicing = resp.data;
          if (this.$store.currentTicket.ticket_servicing_list) {
            this.$store.currentTicket.ticket_servicing_list.push(resp.data);
          } else {
            this.$store.currentTicket.ticket_servicing_list = [resp.data];
          }
          // Обновляем найденные тикеты после вызова
          this.updateFoundTicketsAfterCall(ticket.id);
        }).catch((err) => {
          if(err.response && err.response.data && err.response.data.code && err.response.data.code === this.$ERROR_CODE.BAD_REQUEST) {
            this.reloadAllState();
          }
        })
      }
    },
    websocketSubscribe() {
      this.socketMessageUnsubscription = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.SOCKETS_MESSAGE, (response) => {
        if (!response.payload) return;

        parseJSON(response.payload.payload)
          .then((data) => {
            if (this.OPERATOR_WORKSPACE_SOCKET_EVENT[response.payload.event_type]) {
              this.OPERATOR_WORKSPACE_SOCKET_EVENT[response.payload.event_type](data);
            } else {
              console.error(`Нет обработчика для event_type = ${response.payload.event_type}`, response);
            }
          });
      });

      this.socketReconnectUnsubscription = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.SOCKETS_RECONNECT, () => {
        this.$initService.authorizeOperatorDevice(localStorage.getItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.TOKEN), this.$store.deviceStartData.device.token);
        this.reloadAllState();
      })
    },
    getCurrentState() {
      return new Promise((res, rej) => {
        this.$crudService.get(`device/operator-workspaces/${this.$store.deviceStartData.device.device_id}/current_state`).then((resp) => {
          if (resp && resp.data && (resp.data.is_queue_backup === true || resp.data.is_queue_backup === false)) {
            this.$store.lastCurrentStateMode = resp.data.is_queue_backup;
          }
          res(resp);
        }).catch((err) => {
          rej(err)
        });
      })
    },
    splitIntoGroups() {
      if (this.$store.deviceStartData.window) {
        this.$store.waitingTickets = this.$store.unsortedTickets.filter(ticket => ticket.status_type === TICKET_STATUS.WAITING).reverse();
        this.$store.postponedTickets = this.$store.unsortedTickets.filter(ticket => ticket.status_type === TICKET_STATUS.POSTPONED).reverse();
        this.$store.canceledTickets = this.$store.unsortedTickets.filter(ticket => ticket.status_type === TICKET_STATUS.CANCELED).reverse();
        this.$store.readiedTickets = this.$store.unsortedTickets.filter(ticket => ticket.status_type === TICKET_STATUS.READIED).reverse();

        this.tabs[0].count = this.$store.waitingTickets.length;
        this.tabs[1].count = this.$store.postponedTickets.length;
        this.tabs[2].count = this.$store.canceledTickets.length;
        if (this.canIssueOrder) {
          this.tabs[4].count = this.$store.readiedTickets.length;
        }
      }
    },
    sortTickets() {
      const sortedTickets = this.$store.unsortedTickets.sort((a, b) => {
        return b.priority_time - a.priority_time;
      });

      this.$store.unsortedTickets = sortedTickets;
    },
    makeQueue() {
      this.sortTickets();
      this.splitIntoGroups();
    },
    reloadAllState(data, callNext) {
      if (!this.$store.waitingTickets.length) {
        this.startAutoCallTimer();
      }
      this.getCurrentState().then((resp) => {
        this.initState(resp);
        this.$store.ticketTransactionEnd = true;
        if (callNext) {
          this.onNextSelectTicket()
        }
      });
    },
    onNextSelectTicket() {
      if (this.$store.waitingTickets && this.$store.waitingTickets.length) {
        const currentTicket = this.$store.waitingTickets[0];

        this.callTicket(currentTicket)
      } else {
        this.$store.ticketTransactionEnd = false;
        this.$statusService.changeStatus(1).then(() => {
          this.$store.ticketTransactionEnd = true;
        });
      }
    },
    onTicketClose(ticketServicing) {
      this.$ticketService.closeTicket(ticketServicing).then(() => {
        this.$store.ticketTransactionEnd = true;
      })
    },
    onTicketPostpone(ticketServicing) {
      this.$ticketService.postponeTicket(ticketServicing).then(() => {
        this.$store.ticketTransactionEnd = true;
      })
    },
    onTicketRecall(ticketServicing) {
      this.$ticketService.reCallTicket(ticketServicing.id).then(() => {
        this.$store.ticketTransactionEnd = true;
      });
    },
    onTicketAbsence(ticketServicing) {
      this.$ticketService.absenceTicket(ticketServicing).then(() => {
        this.$store.ticketTransactionEnd = true;
      })
    },
    onTicketRedirect(ticketServicing) {
      this.$store.redirectMode = this.REDIRECT_MODE.REDIRECT;
      this.$modal.show(this.$MODAL_NAME.REDIRECT);
    },
    onOrderAssembled(ticketServicing) {
      this.$ticketService.orderAssembled(ticketServicing).then(() => {
        this.$store.ticketTransactionEnd = true;
      })
    },
    onChangeStatus() {
      this.$modal.show(this.$MODAL_NAME.CHANGE_STATUS);
    },
    closeContextMenu() {
      this.contextMenu.open = false;
      this.contextMenu.ticket = null;
      this.contextMenu.ticketsArray = null;
    },
    openContextMenu(params, accessForOperator, actions, tickets) {
      this.$store.contextMenuActions = actions;

      if (accessForOperator || (!this.currentTicketServicing && this.$authService.isAdmin())) {
        const currentTicket = tickets.find(ticket => ticket.id === params.id);
        this.$store.ticketForContextMenu = currentTicket;
        if (window.innerWidth <= 425) {

          this.$store.mobileTicketModalData = {
            ticket: currentTicket
          };
          this.$modal.show(this.$MODAL_NAME.CALL_TICKET_MOBILE)
        } else {
          this.contextMenu.open = true;
          this.contextMenu.left = `${params.event.pageX - 20}px`;
          this.contextMenu.top = `${params.event.pageY - 20}px`;
          this.contextMenu.ticket = currentTicket;
          this.contextMenu.ticketsArray = tickets; // Сохраняем массив тикетов
        }
      }
    },
    onBackToAlive(access) {
      if (access) {
        this.$store.redirectMode = this.REDIRECT_MODE.BACK_TO_ALIVE;
        this.$modal.show(this.$MODAL_NAME.REDIRECT)
      }
    },
    onTicketCallButtonClick(access) {
      if (access) this.callTicket(this.contextMenu.ticket, this.contextMenu.ticketsArray)
    },
    onOrderIssued() {
      this.$ticketService.orderIssued(this.contextMenu.ticket);
    },
    startAutoCallTimer() {
      this.$ticketService.startAutoCallTimer();
    },
    updateFoundTicketsAfterCall(ticketId) {
      if (this.searchPanelOpen && this.$store.foundTickets) {
        this.$store.foundTickets = this.$store.foundTickets.filter(ticket => ticket.id !== ticketId);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .page-wrapper {
    width: 100vw;
    height: 100vh;
    padding: 16px 56px 24px 56px;
    background-color: var(--light-02);
    overflow: hidden;
    display: flex;
  }

  .ticket-aside {
    width: 384px;
    min-width: 384px;
    margin-right: 32px;
    &__inner {
      height: 100%;
    }
  }

  .tickets-list {
    width: 100%;
    &__body {
      background: var(--light-01);
      box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074), 0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      max-height: calc(100% - 60px);
      overflow: auto;
    }
  }
  @media (max-width: 425px) {
    .page-wrapper {
      flex-wrap: wrap;
      padding: 0;
      overflow: hidden;
    }

    .ticket-aside {
      width: 100%;
      min-width: 0;
      margin-right: 0px;
      height: 100%;
    }

    .tickets-list {
      background: var(--light-01);
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: none;
      &.is--mobile-tickets-open {
        display: block;
      }
      &__body {
        max-height: calc(100% - 97px);
        height: 100%;
        &.is--mobile-open {
          max-height: calc(100% - 49px);
        }
      }
    }

    .tickets-tabs {
      justify-content: space-between;
      height: 100%;
      &__tab {
        span.text {
          display: none;
        }
      }
    }
  }
</style>
